<template>
  <div>
    <section class="product-slider">
      <div class="container">
        <intro-text :text="introText"/>
        <product-list ref="productList" inline-template>
          <carousel :perPageCustom="[[768, 3], [1024, 4]]" :pagination-enabled="false" :mouse-drag="false"
                    :navigation-enabled="true"
                    navigationNextLabel="" navigationPrevLabel="" class="slider">
            <slide v-for="product in products" :key="product.id">
              <div class="product" data-aos="fade-in">
                <a :href="$router.resolve({name: 'product', params: { slug: product.slug }}).href" :title="'Link: ' + product.title">
                  <img v-if="product.images.length > 0" v-bind:src="product.images[0].url" class="img-fluid"
                       :alt="'Image: ' + product.title"/>
                  <p>{{ product.title }}</p>
                </a>
                <span v-bind:class="['favourite', {
                    'active' : $root.isProductInBasket(product.id)
                  }]" v-on:click="toggleProductInBasket($event, product.id)"
                      title="Add or remove from favourites"></span>
              </div>
            </slide>
          </carousel>
        </product-list>
        <router-link :to="{ name: 'products', query: query}" class="cta" title="Link: Products">
          {{ linkText }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
  import ProductList from "./ProductList";
  import {Carousel, Slide} from 'vue-carousel';
  import IntroText from "./IntroText";

  export default {
    name: 'ProductSlider',
    components: {
      IntroText,
      ProductList,
      Carousel,
      Slide
    },
    data() {
      return {
        introText: null,
        linkText: 'View all products',
        query: {}
      };
    },
    methods: {
      loadFilteredProducts: function (filters) {
        this.$refs.productList.filterProducts(filters);
      },
      loadRecommendedProducts: function (product) {
        this.$refs.productList.loadRecommendedProducts(product);
      }
    }
  }
</script>

<style>
  .VueCarousel-wrapper {
    overflow: visible;
  }

  .VueCarousel-navigation-next, .VueCarousel-navigation-prev {
    width: 30px;
    height: 20px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50%;
    outline: none !important;
  }

  .VueCarousel-navigation-next {
    background-image: url("../assets/arrow-right.svg");
  }

  .VueCarousel-navigation-prev {
    left: initial !important;
    right: 0;
    background-image: url("../assets/arrow-left.svg");
  }

  .VueCarousel-navigation {
    position: absolute;
    top: -75px;
    right: 30px;
  }
</style>
